import { Box, Chip, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { formatBytes } from "./cache-utils";

interface CacheSummaryProps {
  totalKeys: number;
  tagCount: number;
  untaggedCount: number;
  totalSizeBytes: number;
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

const CacheSummary = ({
  totalKeys,
  tagCount,
  untaggedCount,
  totalSizeBytes,
  searchTerm,
  onSearchChange,
}: CacheSummaryProps) => (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 1.5,
      mb: 2,
    }}
  >
    <Chip
      label={`${totalKeys} keys`}
      color="primary"
      sx={{ fontWeight: 600 }}
    />
    <Chip label={`${tagCount} tags`} variant="outlined" />
    <Chip label={`${untaggedCount} untagged`} variant="outlined" />
    <Chip label={`${formatBytes(totalSizeBytes)} total`} variant="outlined" />
    <TextField
      size="small"
      placeholder="Filter tags or keys"
      value={searchTerm}
      onChange={(event) => onSearchChange(event.target.value)}
      sx={{ ml: { sm: "auto" }, minWidth: 260 }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        },
        htmlInput: { "aria-label": "Filter tags or keys" },
      }}
    />
  </Box>
);

export default CacheSummary;
